import { Route, Routes } from "react-router-dom";

import { AuthProvider } from "./lib/auth";
import { ScrollToTop } from "./components/ScrollToTop";
import { PublicLayout } from "./components/layout/PublicLayout";
import { AppLayout } from "./components/layout/AppLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PublicExchange from "./pages/PublicExchange";
import NotFound from "./pages/NotFound";

import Dashboard from "./pages/Dashboard";
import Connections from "./pages/Connections";
import NewConnection from "./pages/NewConnection";
import ConnectionDetail from "./pages/ConnectionDetail";
import Exchange from "./pages/Exchange";
import Workflows from "./pages/Workflows";
import ApiDesigner from "./pages/ApiDesigner";
import ApiConsole from "./pages/ApiConsole";
import WorkflowBuilder from "./pages/WorkflowBuilder";
import Copilot from "./pages/Copilot";
import Settings from "./pages/Settings";

export default function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        {/* Public marketing + legal */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/exchange" element={<PublicExchange />} />
        </Route>

        {/* Auth (full-screen split) */}
        {/* Azure AD B2C: one user flow covers sign-in and sign-up */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/onboarding" element={<Onboarding />} />

        {/* Authenticated app */}
        <Route path="/app" element={<AppLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="connections" element={<Connections />} />
          <Route path="connections/new" element={<NewConnection />} />
          <Route path="connections/:slug" element={<ConnectionDetail />} />
          <Route path="exchange" element={<Exchange />} />
          <Route path="workflows" element={<Workflows />} />
          <Route path="workflows/new" element={<WorkflowBuilder />} />
          <Route path="workflows/:slug" element={<WorkflowBuilder />} />
          <Route path="apis" element={<ApiDesigner />} />
          <Route path="apis/:slug" element={<ApiConsole />} />
          <Route path="copilot" element={<Copilot />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
